import { render, staticRenderFns } from "./WhoWeAre.vue?vue&type=template&id=5f88bfb6&scoped=true&"
import script from "./WhoWeAre.vue?vue&type=script&lang=js&"
export * from "./WhoWeAre.vue?vue&type=script&lang=js&"
import style0 from "./WhoWeAre.vue?vue&type=style&index=0&id=5f88bfb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88bfb6",
  null
  
)

export default component.exports